const ADMINS = [
  'Byron.Chang@nike.com',
  'Ryan.Mackey@nike.com',
  'Justin.Habetz@nike.com',
  'Mary.Liu@nike.com',
  'Trixy.Woodhouse@nike.com',
  'Benjamin.Jackson@nike.com',
  'Omar.Valdes@nike.com',
  'Gerrardo.Herrera@nike.com',
  'Alan.Cortez@nike.com',
  'David.Miguel@nike.com',
  'Tim.Odell@nike.com',
  'Adrian.Shepherd@nike.com',
  'Hans.Kersteter@nike.com',
  'Ben.Pickett@nike.com',
  'rodney.young@nike.com',
  'jt.cray@nike.com',
  'Cesar.Contreras2@nike.com',
  'Jose.Armandojimenez@nike.com',
  'Andrew.Taylor@nike.com',
  'Samuel.Martinez2@nike.com',
  'Patrick.Foss@nike.com',
  'Paulina.Casas@nike.com',
  'Gerrardo.Herrera@nike.com',
  'Saul.Iribe@nike.com',
  'Phillip.Loughran@nike.com',
  'Keegan.Flannigan@nike.com',
  'Vishesh.Waghmare@nike.com',
  'Minia.Oseguera@nike.com',
];

export const isAdmin = userEmail => {
  if (!userEmail) {
    return false;
  }
  if (ADMINS.indexOf(userEmail) >= 0) {
    return true;
  } else {
    return false;
  }
};
